import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import axios from 'axios';

// 设置 axios 默认配置
axios.defaults.baseURL = process.env.NODE_ENV === 'production' 
  ? 'https://steamfamilyweb.tginot.com'  // 生产环境域名
  : 'http://localhost:3001';  // 开发环境
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.timeout = 35000; // 增加到 35 秒，比服务器端多 5 秒

// 添加请求拦截器
axios.interceptors.request.use(config => {
  console.log('发送请求:', config.url, config.data);
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  console.error('请求错误:', error);
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    console.log('收到响应:', response.data);
    return response;
  },
  error => {
    console.error('响应错误:', error.response || error);
    if (error.response?.status === 401) {
      // 如果收到 401 响应，清除 token 并跳转到登录页面
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 